import { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import PatreonNav from "../components/PatreonNav";
import PatreonFooter from "../components/PatreonFooter";
import HeroSection from "../components/home/HeroSection";
import CreativitySection from "../components/home/CreativitySection";
import CreativeControlSection from "../components/home/CreativeControlSection";
import CommunitySection from "../components/home/CommunitySection";
import BusinessSection from "../components/home/BusinessSection";
import CreatorShowcase from "../components/home/CreatorShowcase";
import CTASection from "../components/home/CTASection";

const HomePage = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <Helmet>
        <title>Patreon - Where podcasts grow</title>
        <meta
          name="description"
          content="Patreon is the best place to build community with your biggest fans, share exclusive work, and turn your passion into a lasting creative business."
        />
        <link rel="canonical" href={window.location.origin + "/"} />
        <meta property="og:title" content="Patreon - Where podcasts grow" />
        <meta
          property="og:description"
          content="Patreon is the best place to build community with your biggest fans, share exclusive work, and turn your passion into a lasting creative business."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={window.location.href} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Patreon - Where podcasts grow" />
        <meta
          name="twitter:description"
          content="Patreon is the best place to build community with your biggest fans."
        />
      </Helmet>

      <div
        className="min-h-screen bg-white"
        style={{
          fontFamily: 'var(--patreon-font-primary)',
        }}
      >
        {/* Navigation */}
        <PatreonNav scrolled={scrolled} />

        {/* Hero Section - "Where podcasts grow" */}
        <HeroSection />

        {/* Creativity powered by fandom */}
        <CreativitySection />

        {/* Complete creative control */}
        <CreativeControlSection />

        {/* Creators. Fans. Nothing in between */}
        <CommunitySection />

        {/* Turning passions into businesses */}
        <BusinessSection />

        {/* Creator Showcase Grid */}
        <CreatorShowcase />

        {/* Final CTA Section */}
        <CTASection />

        {/* Footer */}
        <PatreonFooter />
      </div>
    </>
  );
};

export default HomePage;

